import { useSelector } from "react-redux";

const useGetPermission = ({
  permissionParentKey,
  permissionChildKey,
  showOnLocalSetup = false,
}) => {
  const { permissions } = useSelector(
    (state) => state.profileDetailsReducer.profileDetails,
  );
  const isLocalSetup =
    process.env.REACT_APP_ENV === "localSetup" ? true : false;

  const isPermitted = () => {
    if (permissions?.[permissionParentKey]?.includes(permissionChildKey))
      return true;
    else if (
      permissions?.[permissionParentKey]?.length > 0 &&
      permissionChildKey === undefined
    )
      return true;
    else if (
      permissionChildKey === undefined &&
      permissionParentKey === undefined
    )
      return true;
    else return false;
  };

  return {
    isPermitted:
      (isPermitted() && !isLocalSetup) || (isPermitted() && showOnLocalSetup),
    isLocalSetup,
  };
};
export default useGetPermission;
